import { useEffect } from 'react';
import { Link as RouterLink } from 'react-router-dom';
import {
  Box,
  Card,
  CardActionArea,
  CardContent,
  Chip,
  Container,
  Grid,
  Stack,
  Typography,
} from '@mui/material';

const tools = [
  {
    href: '/tools/heat-seeder',
    title: 'Heat seeder',
    body: 'Paste a list of seed times. Get cleanly seeded heats and lane assignments.',
    badge: 'Free',
  },
  {
    href: '/tools/parent-email',
    title: 'Parent email generator',
    body: 'Paste your meet roster. Get a clean, copy-pastable email per parent.',
    badge: 'Soon',
  },
  {
    href: '/tools/fat-converter',
    title: 'FAT ↔ hand-time converter',
    body: 'Convert hand times to FAT-equivalent and vice versa.',
    badge: 'Soon',
  },
  {
    href: '/tools/age-grade',
    title: 'Age-grade calculator',
    body: 'Compare performances across ages and events using WMA tables.',
    badge: 'Soon',
  },
];

export default function ToolsIndexPage() {
  useEffect(() => {
    document.title = 'Free tools for track & field coaches — Baton';
    window.scrollTo({ top: 0 });
  }, []);

  return (
    <Container maxWidth="lg" sx={{ py: { xs: 6, md: 9 } }}>
      <Box sx={{ maxWidth: 640 }}>
        <Typography variant="h3" component="h1" sx={{ fontWeight: 800, letterSpacing: '-0.02em' }}>
          Free tools
        </Typography>
        <Typography color="text.secondary" sx={{ mt: 1.5 }}>
          No signup, no email gate. Just small utilities that solve the annoying bits of coaching
          track and field. Built by coaches, free for everyone.
        </Typography>
      </Box>

      <Grid container spacing={2.5} sx={{ mt: 4 }}>
        {tools.map((t) => (
          <Grid item xs={12} sm={6} key={t.href}>
            <Card
              variant="outlined"
              sx={{
                borderRadius: 3,
                height: '100%',
                transition: 'transform .15s ease, box-shadow .15s ease',
                '&:hover': { transform: 'translateY(-2px)', boxShadow: 4 },
              }}
            >
              <CardActionArea component={RouterLink} to={t.href} aria-label={`Open ${t.title}`} sx={{ height: '100%', p: 0 }}>
                <CardContent sx={{ p: 3, height: '100%' }}>
                  <Stack direction="row" justifyContent="space-between" alignItems="flex-start" sx={{ mb: 1 }}>
                    <Typography variant="h6" sx={{ fontWeight: 700 }}>
                      {t.title}
                    </Typography>
                    <Chip
                      label={t.badge}
                      size="small"
                      sx={{ bgcolor: '#fef7ec', color: '#92400e', fontWeight: 600 }}
                    />
                  </Stack>
                  <Typography variant="body2" color="text.secondary">{t.body}</Typography>
                  <Typography variant="body2" sx={{ mt: 2, fontWeight: 700, color: 'primary.main' }}>
                    Open tool →
                  </Typography>
                </CardContent>
              </CardActionArea>
            </Card>
          </Grid>
        ))}
      </Grid>
    </Container>
  );
}
